exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8wd18zaRFq-MMpItphV_w {\n    background-color:  #EEEEEF;\n}\n\n._3e54_Qn1qp6NtPkEfZuKXj {\n    max-width: 700px;\n    padding: 0;\n    margin-top: 20px;\n}\n\n._3e54_Qn1qp6NtPkEfZuKXj > * {\n    width: 100%;\n    height: 100%;\n}\n\n._1mwTp7dcEFF_imOm9q85_j {\n    background-color: #EEEEEF;\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%);\n    padding-bottom: 5%;\n    margin-top: -1px;\n}\n\n._2tgv7vPKYlslkNZ0ziae3z {\n    background-color: #EEEEEF;\n    clip-path: polygon(0% 100%, 100% 100%, 100% 0%);\n    padding-bottom: 5%;\n    margin-bottom: -1px;\n}\n\n\n", ""]);

// exports
exports.locals = {
	"background-gray": "_8wd18zaRFq-MMpItphV_w",
	"backgroundGray": "_8wd18zaRFq-MMpItphV_w",
	"image": "_3e54_Qn1qp6NtPkEfZuKXj",
	"polygon-bottom-slope": "_1mwTp7dcEFF_imOm9q85_j",
	"polygonBottomSlope": "_1mwTp7dcEFF_imOm9q85_j",
	"polygon-top-slope": "_2tgv7vPKYlslkNZ0ziae3z",
	"polygonTopSlope": "_2tgv7vPKYlslkNZ0ziae3z"
};